"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lib_1 = require("@brandfree-front/lib");
class GaButton extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(lib_1.AnalyticsTrigger, { trigger: { id: `Button - ${this.props.id}`, callback: 'onClick' } },
            react_1.default.createElement(lib_1.Button, { ...this.props })));
    }
}
exports.default = GaButton;
